
// SECRET - KEYS

//  JWPLAYER
const jwPlayerLicenseKey = 'FBK5tlpJ61A5Z0mbWc+fvpeqCDPPi1w01+mYvfx5yojfNazt';

//  CHAT - external login app
const facebookAppId = '191063691515498';   // Example: '1088597931155576'
// googleClientId - Example: '658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com'
const googleVdmplayerId = '608999539073-51s2o1r5puqkeu72uv5ik2iorec50948.apps.googleusercontent.com';
const googleDemocdnplayerId = '608999539073-4c74a3sm71i0f6ek7auldqmel2n4tdn7.apps.googleusercontent.com';
const googleCdnapiId = '608999539073-a1vgv9tk3n2rggi4fgdr9oe675fp8urr.apps.googleusercontent.com';

//  HTML5 - GOOGLE GEOCODE - geobloqueo
const googleMapsApiKey = 'AIzaSyBzyrrHDnZEnyk3VGvSdFjJWdLvhOlu7xg';

const externalConfiguration = {       // MARCA
  defaultPlaybackRateControls: [ 0.25, 0.5, 1, 1.5, 2],
  defaultPlayerContainerId: 'custom-base-player',
  jwPlayerSelfHostedPath: '/vdmplayer/jwplayer-7.12.8/jwplayer.js',
  jwPlayerSelfHostedPath_lowlatency: '/vdmplayer/jwplayer_lowlatency-7.12.8/jwplayer.js',
  jwPlayerLicenseKey,
  jwPlaylistDefaultUrlFields: ['image','link'],
  chatBackEndDomain: '',
  chatRootPath: '/apicloud/v1.0/public/',
  cdnProgressiveDomain: '//progressive.codev8.net',
  cdnVideosDomain: '//storagecdn.codev8.net',
  cdnPlaybackDomain: '//stgcdnvod.codev8.net',
  apiDirectDomain: '//cms.codev8.net',
  // apiDirectDomain: '//maquina.codev8.net',           // TESTING
  apiCDNDomain: '',
  // apiCDNDomain: '//cdnapi.codev8.net',               // PROD-FROM-LOCAL
  // apiCDNDomain: '//maquina.codev8.net',              // TESTING
  // apiCDNDomain: 'https://maquina.codev8.net:8443',   // PRE-TESTING
  // apiCDNDomain: '//localhost.codev8.net:8080',       // DEVELOP
  apiPublicPath: '/apicloud/v1.0/public/',
  apiDelayedPath: '/apicloud/v1.0/delay/',
  defaultBlockImagePath: '//progressive.codev8.net/streamvdn/public/img/',
  defaultBlockImage: '/vdmplayer/resources/block.png',
  defaultErrorVideo: '/vdmplayer/resources/streamerror.mp4',
  defaultDownloadButtonImage: '/vdmplayer/resources/download_1.svg',
  defaultImageDown: '/vdmplayer/resources/emission_down.jpg',
  defaultPlayerAboutText: '',
  defaultPlayerAboutLink: '',
  backupPlaybackDomains: {
    '//cdnvod.codev8.net': [ '//stgcdnvod.codev8.net'],
    // '//democdnvod.codev8.info': [],
    '//storagecdn.codev8.net': [ '//storagecdntest.codev8.net'],
    '//stgcdnvod.codev8.net': [],
    '//cdnlive.codev8.net': [ '//originlive2.codev8.net', '//cdnliveb.codev8.net', '//cdnlive.codev8.info'],
    'default': [],
  },
  tokenOverridenPlaybackDomains: {
    // '//cdnlive.codev8.net': ['//cdnlive2.codev8.net'],
  },
  versionData: {
    versionCode: '1.0',
    commitId: '',
    date: '',
  },
  taggingSettings: {
    playerSize: 0.64,
  },
  chatSettings: {
    refreshInterval: 10*1000,
    playerSize: 0.7,
    facebookAppId,
    googleVdmplayerId,
    googleDemocdnplayerId,
    googleCdnapiId,
  },
  defaultDesign: {
  	name: 'glow',
  	active: '#666666',
  	inactive: '#aaaaaa',
  	background: 'rgba(0,0,0,1)',
  },
  googleMapsApiKey,
};

export default externalConfiguration;



// WEBPACK FOOTER //
// ./src/external-configuration.js